/**
 * Configuration
 * @module config
 */

const config = {
  name: 'KineticoPRO',
  description: 'Kinetico Incorporated',
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  CONSUMPTION_BASE_URL: process.env.REACT_APP_CONSUMPTION_BASE_URL,
  CONSUMPTION_API_KEY: process.env.REACT_APP_CONSUMPTION_API_KEY,
  BUCKET_NAME: 'ota-versions',
  ACCOUNTS_CSV_EXAMPLE_URL: 'https://www.aquarianhub.com/account_csv_example.csv',
  LOCATIONS_CSV_EXAMPLE_URL: 'https://www.aquarianhub.com/location_csv_example.csv',
};

export default config;
